/*
 * 获取单个URL参数
 */
import {realType} from 'bjxy-common/helper/utils';

export function getQuery(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
export function addQuerys(obj,src) {
    var location_href=src||window.location.href
    var newQuery='',reg
    var v1=location_href.indexOf('?')+1
    var v2=location_href.indexOf('#')
    for (var key in obj){newQuery+=key+'='+obj[key]+'&'}
    if(v1){
      reg =new RegExp("(.{" + v1 + "})");
      return location_href.replace(reg, "$1"+newQuery)

    }else if(v2>-1){
      newQuery='?'+newQuery.slice(0,-1)
      reg =new RegExp("(.{" + v2 + "})");
      return location_href.replace(reg,"$1"+newQuery)
    }else {
      return location_href+'?'+newQuery.slice(0,-1)
    }
}

export function addUrlQuerys(url, query) {
  if(typeof url !== 'string' || !query){
    return url
  }
  if(realType(query) === 'object'){
    var str = '';
    for (let key in query){
      str += `${key}=${query[key]}&`
    }
    query = str.slice(0,-1)
  }
  if(/\?/.test(url.split('#')[0])){
    return url.replace(/\?/,'$&'+query+'&')
  }else {
    return url.replace(/#|$/,'?'+query+'$&')
  }
}
/*
 * 获取所有URL参数
 */
export function getQueryAll() {
  let params = {};
  let searchSplit = location.search.substring(1).split('&');
  for (let i = 0; i < searchSplit.length; i++) {
    let p = searchSplit[i].split('=');
    if (p[0]) {
      params[p[0]] = decodeURIComponent(p[1]);
    }
  }
  return params;
}
/*
 * 获取当前url所在目录
 */
export function getCurrentPath() {
  let urlPath = window.location.origin + window.location.pathname;
  let m = urlPath.match(/^(.+\/)[^\/]+$/);
  return m ? m[1] : urlPath;
}

export function delQuery(url ,name) {
  if(!Array.isArray(name)){
    name = [name]
  }
  name.forEach(function (item) {
    var reg = new RegExp( item + '=[^&#]*([&#]|$)', 'igm');
    url =  url.replace(reg, function (re1,re2) {
      if(re2 === '#'){
        return '#'
      }else {
        return ''
      }
    });
  })
  return url
}
export default {
  getQuery,
  getQueryAll,
  getCurrentPath,
  addQuerys,
  addUrlQuerys,
  delQuery
};



// WEBPACK FOOTER //
// ./src/component/common/uri.js